import { render, staticRenderFns } from "./PendingAndCommToDos.vue?vue&type=template&id=98539690&scoped=true&"
import script from "./PendingAndCommToDos.vue?vue&type=script&lang=ts&"
export * from "./PendingAndCommToDos.vue?vue&type=script&lang=ts&"
import style0 from "./PendingAndCommToDos.vue?vue&type=style&index=0&id=98539690&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98539690",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
